<template>
    <div>
        <b-modal
            ref="barcodeScanner"
            title="Scan Part Number"
            ok-variant="light"
            ok-title="Cancel"
            ok-only
        >
            <div class="text-center text-danger">
                {{error}}
            </div>
            <qrcode-stream @decode="onDecode" @init="onInit" />
        </b-modal>

        <a class="btn btn-outline-success text-success" @click="showModal()">
            <i class="fa fa-camera"></i>
        </a>
    </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';

export default {
  name: 'BarcodeScanner',
  components: { 'qrcode-stream': QrcodeStream },
  data() {
    return {
      error: '',
    };
  },
  methods: {
    showModal() {
      this.$refs.barcodeScanner.show();
    },
    ok() {

    },
    onDecode(result) {
      this.$emit('scanned', result);
      this.$refs.barcodeScanner.hide();
    },
    async onInit(promise) {
      try {
        await promise;
      }
      catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = 'You need to grant permission to access the camera';
        }
        else if (error.name === 'NotFoundError') {
          this.error = 'No camera found on this device';
        }
        else if (error.name === 'NotSupportedError' || error.name === 'StreamApiNotSupportedError') {
          this.error = 'This browser does not support this feature';
        }
        else if (error.name === 'NotReadableError' || error.name === 'OverconstrainedError') {
          this.error = 'The camera could not be read';
        }
      }
    },
  },
};
</script>

<style lang="scss">
/*
#barcode-scanner {
    position: relative;
    height: 288px;

    video {
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -176px;
    }

    canvas.drawingBuffer {
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -176px;
    }
}
*/
</style>
